import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import _ from 'lodash'

type Value = string | number | Record<PropertyKey, unknown> | null

interface IProps {
  label?: string
  labelClass?: string
  clickable?: boolean
  val?: Value
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'BaseToggleLine' },
  __name: 'BaseToggleLine',
  props: /*@__PURE__*/_mergeModels({
    label: { default: '' },
    labelClass: { default: 'fs-15px fw-500' },
    clickable: { type: Boolean, default: true },
    val: { default: null }
  }, {
    "modelValue": { type: [Boolean, Array], ...{ required: true } },
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {


const props = __props
const model = _useModel<boolean | Value[]>(__props, "modelValue")

function handleToggle() {
  if (typeof model.value === 'boolean') {
    model.value = !model.value
    return
  }

  const exists = model.value.some((value) => _.isEqual(value, props.val))
  model.value = exists ? model.value.filter((value) => !_.isEqual(value, props.val)) : [...model.value, props.val]
}

return (_ctx: any,_cache: any) => {
  const _component_k_toggle = _resolveComponent("k-toggle")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["BaseToggleLine row no-wrap items-center justify-between", { 'cursor-pointer': __props.clickable }]),
    onClick: handleToggle
  }, [
    _renderSlot(_ctx.$slots, "label", {}, () => [
      _createElementVNode("span", {
        class: _normalizeClass(["transition", [model.value ? 'text-cool-gray-100' : 'text-cool-gray-70', __props.labelClass]])
      }, _toDisplayString(__props.label), 3)
    ]),
    _createVNode(_component_k_toggle, {
      modelValue: model.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
      val: __props.val
    }, null, 8, ["modelValue", "val"])
  ], 2))
}
}

})